import toUpper from 'lodash/toUpper'
import { hasMethod } from '~/utils/framework'

/**
 * Look for the first tag in the event propagation path.
 * @param {string} tag
 * @param {MouseEvent} e
 * @return {HTMLElement|null}
 */
export function findNodeInEventPath (tag, e) {
  if (typeof tag !== 'string') return null
  if (!hasMethod(e, 'propagationPath')) return null

  tag = toUpper(tag)
  const path = e.propagationPath()

  for (let i = 0; i < path.length; i++) {
    if (path[i].tagName === tag) {
      return path[i]
    }
  }

  return null
}

/**
 * @param {Vue} parent
 * @returns {VNodeData}
 */
export function getScopedStyleData (parent) {
  let data = { attrs: {} }

  if (parent.$options._scopeId) {
    data.attrs[`${parent.$options._scopeId}`] = ''
  }

  return data
}
